<acabim-card cardHeading="Settings" [cardContent]="settingsList">

</acabim-card>

<ng-template #settingsList>
    <ul *ngFor="let route of routes">
        <li><a routerLink="{{route.link}}">{{route.title}}</a></li>
    </ul>
</ng-template>
